<ng-container *hasPermission="PermissionForStudents.NOTIFICATION_VIEW">
 <ng-container *ngIf="isLoading; else notificationPage">
  <div class="app-spinner">
    <mat-spinner diameter=60></mat-spinner>
  </div>
</ng-container>

<ng-template #notificationPage>
  <div class="icon-wrapper">
      <div class="notifications">
        <div class="dropdown-header">
          <div class="left">	
            <h4>
				<span (click)="goToHome()">
				<i class="bi bi-arrow-left"></i>
				</span>
				All Notifications {{unreadNotificationCount || 0 }}</h4>
          </div>
          <button class="mark-all" (click)="markAllNotificationsAsRead()"
		 	*hasPermission="PermissionForStudents.NOTIFICATION_MARK_AS_READ">Mark all read</button>
        </div>

        <div class="notification-list">
          <ng-container *ngIf="studentNotifications.length > 0; else noNotifications">
            <div class="notification-item" *ngFor="let notification of studentNotifications"
		 	 [class.unread]="!notification.is_read" (click)="onNotificationClick(notification)" 
		 	 [ngClass]="'card-' + (notification.content_type || 'general').toLowerCase()">

              <div class="icon" [ngClass]="'icon-' + (notification.content_type || 'general').toLowerCase()">
                <i class="material-icons">{{ getNotificationIcon(notification.content_type) }}</i>
              </div>
              <div class="text">
                <h5>{{ notification.title }}</h5>
			  	<h6>{{notification.message}}</h6>
                <div class="time">
                  <i class="material-icons">access_time</i>{{ notification.created_at | istDate }}
                </div>
              </div>
              
              <div class="actions" style="display: flex; align-items: center; gap: 10px;">
                <span class="dot" *ngIf="!notification.is_read"></span>
                <img
                  src="assets/images/delete.svg"
                  alt="delete"
                  style="width: 16px; height: 16px; cursor: pointer; pointer-events: auto;"
                  (click)="openDeleteNotificationBox(notification.id); $event.stopPropagation()" />
              </div>
            </div>
          </ng-container>
          <ng-template #noNotifications>
            <div class="no-notifications-placeholder">
              <i class="material-icons">notifications_none</i>
              <p>No new notifications</p>
            </div>
          </ng-template>
        </div>

      </div>
    </div>
</ng-template>
</ng-container>